__turbopack_context__.v({
  "loader": "ri-1Fa_loader",
});
